module.exports = {
  it: 'Italiano',
  ko: '한국어',
  th: 'ไทย',
  'zh-tw': '中文 (繁體)',
  id: 'Bahasa Indonesia',
  ar: 'العربية',
  de: 'Deutsch',
  fr: 'Français',
  'pl': 'Polski',
  'pt-pt': 'Português (Portugal)',
  'pt-br': 'Português (Brasil)',
  'es-es': 'Español (España)',
  es: 'Español',
  en: 'English (US)',
}
